module.exports = __webpack_public_path__ + "static/img/1026.8bf5713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1026.jpg
// module id = 208
// module chunks = 0